import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

import { Box, Flex } from "../../style/Grid";
import { Text } from "../../style/Text";
import Filter from "./index";
import { ButtonFilter } from "../../style/ButtonFilter";
import { FilterClear } from "../../style/ButtonFilter/FilterClear";
import nbsp from "../../utils/nbsp";

const MAGICAL_TOP_OFFSET = 90;
const WRAPPER_TOP_OFFSET = 510;

let lock = false;
let timeout = null;

const FilterSidebar = ({
  setBlogPagesToShow,
  pagesToShow,
  jobsLimit,
  filterShow,
  resetFilter,
  handleChange,
  filterData,
  handleShowFilter,
  type,
  hideCertainFilter,
}) => {
  const wrapperRef = useRef(null);
  const filterRef = useRef(null);
  const formRef = useRef(null);

  const [scrollOffsetFixedStart, setScrollOffsetFixedStart] = useState(null);
  const [scrollOffsetFixedEnd, setScrollOffsetFixedEnd] = useState(null);

  const haveSomeFilter = () => {
    let filter = false;
    if (Object.keys(filterData).length !== 0) {
      Object.entries(filterData).forEach(([key]) => {
        if (filterData[key].length !== 0) {
          filter = true;
        }
      });
    }
    return filter;
  };

  useLayoutEffect(() => {
    const scrollTop =
      document.body.scrollTop || document.documentElement.scrollTop;
    const wrapperPadding = 140;

    if (wrapperRef && filterRef && formRef) {
      const { height: formHeight } = formRef.current.getBoundingClientRect();
      const { height: filterHeight } =
        filterRef.current.getBoundingClientRect();

      if (filterShow) {
        wrapperRef.current.style.overflowY = "scroll";
      }
      wrapperRef.current.style.minHeight = !filterShow
        ? formHeight + 120 + "px"
        : formHeight + 120 + MAGICAL_TOP_OFFSET + "px";
      // wrapperRef.current.style.minHeight = h ? formHeight + 120 + "px" : 'calc(100vh + 80px)';
      filterRef.current.style.height = formHeight + MAGICAL_TOP_OFFSET + "px";

      const { bottom: wrapperViewportBottom, top: wrapperViewportTop } =
        wrapperRef.current.getBoundingClientRect();

      const wrapperTop = wrapperViewportTop + scrollTop;
      const wrapperBottom = wrapperViewportBottom + scrollTop;

      setScrollOffsetFixedStart(WRAPPER_TOP_OFFSET);
      setScrollOffsetFixedEnd(wrapperBottom - filterHeight - wrapperPadding);
    }
  }, [
    filterData,
    jobsLimit,
    pagesToShow,
    filterShow,
    type,
    setBlogPagesToShow,
    scrollOffsetFixedEnd,
  ]);

  useEffect(() => {
    function handleScroll() {
      if (timeout) {
        clearTimeout(timeout);
      }

      if (lock) {
        setTimeout(() => (lock = false), 50);
        timeout = setTimeout(handleScroll, 100);
        return;
      }
      lock = true;

      const scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;

      if (
        scrollTop > scrollOffsetFixedStart &&
        scrollTop < Math.abs(scrollOffsetFixedEnd)
      ) {
        filterRef.current.style.position = "fixed";
        filterRef.current.style.top = MAGICAL_TOP_OFFSET + "px";
      } else {
        filterRef.current.style.position = "static";
      }

      if (scrollTop > Math.abs(scrollOffsetFixedEnd)) {
        wrapperRef.current.style.justifyContent = "flex-end";
      }
      if (scrollTop < Math.abs(scrollOffsetFixedEnd)) {
        wrapperRef.current.style.justifyContent = "flex-start";
      }
    }

    window.addEventListener("scroll", handleScroll);

    return function cleanup() {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  let filterText = haveSomeFilter() ? "Filtrovat" : "Zavřít";

  return (
    <Flex
      position={["absolute", null, null, "static", "static"]}
      height={["100vh", null, null, "auto", "auto"]}
      zIndex={["999", null, null, 1, null]}
      top={[0, null, null, "auto", "auto"]}
      display={
        filterShow
          ? ["block", null, null, "flex", null]
          : ["none", null, null, "flex", null]
      }
      width={["100%", null, null, "38%", "31.25%"]}
      backgroundColor="EYYellow.default"
      py={["32px", null, null, "70px", null]}
      pr={["10px", null, null, "2%", "80px"]}
      pl={["10px", null, null, "31px", 0]}
      ref={wrapperRef}
      flexDirection={"column"}
    >
      <Box
        width={["100%", null, null, "320px", null]}
        ref={filterRef}
        flexDirection={"column"}
        alignItem={"center"}
      >
        <Flex justifyContent="space-between" alignItems="flex-end">
          <Text>Filtry</Text>
          {haveSomeFilter() && (
            <FilterClear onClick={resetFilter}>Vymazat vše</FilterClear>
          )}
        </Flex>
        <Filter
          handleChange={handleChange}
          filterData={filterData}
          dataType={type}
          hideCertainFilter={hideCertainFilter}
          passRef={formRef}
        />
        {!filterShow && (
          <Box display={["flex", null, null, "none", null]}>
            <ButtonFilter onClick={handleShowFilter}>
              {nbsp(filterText)}
            </ButtonFilter>
          </Box>
        )}
      </Box>
      {filterShow && (
        <Box display={["flex", null, null, "none", null]}>
          <ButtonFilter onClick={handleShowFilter}>
            {nbsp(filterText)}
          </ButtonFilter>
        </Box>
      )}
    </Flex>
  );
};

export default FilterSidebar;
